export const ORDER_LIST_STATE_KEY = "ordersList";
export const ORDER_LIST_STATE_VERSION = 1;

const serializeDateRange = (value) =>
  Array.isArray(value) ? value.map((date) => (date ? new Date(date).toISOString() : null)) : [];

const deserializeDateRange = (value) =>
  Array.isArray(value) ? value.map((date) => (date ? new Date(date) : null)) : [];

export const createOrderListSnapshot = ({ filters = {}, ...state }) => ({
  version: ORDER_LIST_STATE_VERSION,
  ...state,
  filters: {
    ...filters,
    loadingDate: serializeDateRange(filters.loadingDate),
    creationDate: serializeDateRange(filters.creationDate),
  },
});

export const readOrderListSnapshot = (locationState) => {
  const snapshot = locationState?.[ORDER_LIST_STATE_KEY];

  if (!snapshot || snapshot.version !== ORDER_LIST_STATE_VERSION) {
    return null;
  }

  return {
    ...snapshot,
    filters: {
      ...(snapshot.filters || {}),
      loadingDate: deserializeDateRange(snapshot.filters?.loadingDate),
      creationDate: deserializeDateRange(snapshot.filters?.creationDate),
    },
  };
};
